import { useDispatch, useSelector } from "react-redux";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { setIsLoading } from "../slices/reportSlice";
import * as services from "../services/reportApi";
import { generateRandomString } from "utils/helper";
import * as slices from "../slices/reportSlice"
import { setReportTableLeaveRights } from "../slices/reportSlice";
import { getEmployeeStatusTypeOptions, getEmploymentTypeOptions } from "features/masterData/services/optionsApi";
import useOptions from "features/masterData/hooks/useOptions";
import { useTranslation } from "react-i18next";
import * as employeeServices from "features/employee/services/employeeApi";
import Search from "antd/es/transfer/search";

function useLeaveRightsGroup() {
    const [showReport, setShowReport] = useState(false);
    const { t, i18n } = useTranslation();
    const [lang, setLang] = useState("en");
    const dispatch = useDispatch();
    const reportTableLeaveRights = useSelector((state) => state.report.reportTableLeaveRights || []);
    const [pagination, setPagination] = useState({ current: 0, page: 0, size: 10 });
    const currentCompany = useSelector((state) => state.company.currentCompany);
    const [departmentListOption, setDepartmentListOption] = useState([]);
    const [employeeOptions, setEmployeeOptions] = useState([]);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const showModal = () => {
        setIsModalOpen(true);
    };

    const [search, setSearch] = useState({});
    const modifiedEmployeeOptions = useMemo(() => {
        return employeeOptions.map((opt) => ({
            ...opt,
            label: lang === "en" ? opt.fullNameEn : opt.fullName,
            value: opt.id,
        }));
    }, [lang, employeeOptions]);

    const getEmployeeOptions = useCallback(async () => {
        if (typeof currentCompany !== "object") {
            try {
                dispatch(setIsLoading(true));
                const values = {
                    requestId: generateRandomString(),
                    companyId: currentCompany,
                };
                const response = await employeeServices.getDropDown(values);
                setEmployeeOptions(response.data);
            } catch (error) {
                alert({ type: "error", resultObject: error });
            } finally {
                dispatch(setIsLoading(false));
            }
        }
    }, [currentCompany, dispatch]);

    const modifiedDepartmentOption = useMemo(() => {
        const modifiedOptions = departmentListOption?.map((opt) => ({
            ...opt,
            value: opt?.id,
            label: i18n.language === "en" ? opt?.nameEn : opt?.name,
        }));

        return modifiedOptions;
    }, [i18n.language, departmentListOption]);

    function toParams(params = {}) {
        const { pagination = {}, sortBy = [] } = params;
        const modifiedParams = {
            pagination: {
                page: pagination?.page,
                size: pagination?.pageSize,
            },
            sortBy: sortBy
                .filter((s) => s.order !== undefined)
                .map((s) => ({
                    direction: s.order === "descend" ? "desc" : "asc",
                    property: s.field,
                })),
        };
        return modifiedParams;
    }

    const getReportTableLeaveRights = useCallback(
        async (params = {}) => {
            try {
                dispatch(setIsLoading(true));
                const response = await services.getReportTableLeaveRights({
                    requestId: generateRandomString(),
                    companyId: currentCompany,
                    ...params,
                    ...params.pagination,
                    sortBy: params.sortBy

                });

                console.log("Response data jaaa", response?.data?.page);
                dispatch(setReportTableLeaveRights(response?.data?.page?.content));
                setPagination({
                    ...pagination,
                    // ...params?.request,
                    current: response?.data?.page?.pageable?.pageNumber + 1,
                    pageNo: response?.data?.page?.pageable?.pageNumber + 1,
                    size: response?.data?.page?.pageable?.pageSize,
                    total: response.data?.page?.totalElements,
                });
            } catch (error) {
                console.error("Error fetching report history:", error);
            } finally {
                dispatch(setIsLoading(false));
            }
        },
        [dispatch, reportTableLeaveRights, pagination]
    );




    const getDepartment = useCallback(async () => {
        if (!currentCompany) return null;
        try {
            dispatch(setIsLoading(true));
            const response = await services.getDepartmentOptions({
                requestId: generateRandomString(),
                companyId: currentCompany,
            });
            dispatch(setDepartmentListOption(response.data));
        } catch (error) {
            // alert({ type: "error", resultObject: error });
        } finally {
            dispatch(setIsLoading(false));
        }
    }, [currentCompany, dispatch]);


    const exportLeaveQuotaReport = useCallback(
        async (params = {}) => {
            console.log("params", search);
            try {
                dispatch(setIsLoading(true));
                services.ExportQuotaLeaveReportReportPaging({
                    requestId: generateRandomString(),
                    companyId: currentCompany,
                    ...params,
                    ...params.pagination,
                    ...search,
                    ...pagination,
                    isReport: "Y",
                    sortBy: params.sortBy
                }).then(res => {
                    const url = window.URL.createObjectURL(res?.data);
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', "QuotaLeaveReport.xlsx");
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                });
            } catch (error) {
                console.error("Error fetching report history:", error);
            } finally {
                dispatch(setIsLoading(false));
            }
        },
        [currentCompany, dispatch, search]
    );


    const onChange = useCallback(
        (tablePagination, tableFilters, tableSorter, tableExtra) => {
            console.log('table', tablePagination);

            const modifiedSorter = Array.isArray(tableSorter)
                ? [...tableSorter]
                : [tableSorter];
            const modifiedParams = toParams({
                pagination: {
                    page: tablePagination.current - 1,
                    pageSize: tablePagination.pageSize,
                    current: tablePagination.current - 1,
                },
                sortBy: modifiedSorter,
            });
            setPagination({ ...pagination, ...modifiedParams?.pagination })
            getReportTableLeaveRights({ ...modifiedParams, request: pagination.request, ...search });
        },
        [getReportTableLeaveRights, pagination]
    );



    const handleSearch = (values) => {
        console.log('val', values);

        setShowReport(true)

        setSearch({})
        console.log("year", setShowReport);
        getReportTableLeaveRights({ ...values, year: values?.year?.format("YYYY"), pagination: { page: 0, size: 10 } })
        setSearch({ ...values, year: values?.year?.format("YYYY") })
    };

    useEffect(() => {
        setLang(i18n.language);
    }, [i18n.language, setLang]);

    useEffect(() => {
        getDepartment();
        getEmployeeOptions();
    }, [getDepartment, getEmployeeOptions])

    return {
        handleSearch,
        showReport,
        onChange,
        pagination,
        exportLeaveQuotaReport,
        getReportTableLeaveRights,
        reportTableLeaveRights,
        employeeOptions: modifiedEmployeeOptions,
        departmentOptions: modifiedDepartmentOption,
        isModalOpen,
        setIsModalOpen,
        showModal
    }
}
export default useLeaveRightsGroup;